import classes from "./Loader.module.css";
import React from "react";
export const Loader = () => {
    return(
        <div >
            <div className={classes.loader}></div>
            <p style={{textAlign: "center"}}>Загружаю данные</p>
        </div>
    );
}